<template>
<!-- 选择工程阶段（工程阶段） -->
    <el-dialog title="选择项目标段" :visible.sync="visible" width="800px" :before-close="befclose">
        <div>
            <div v-for="(data, key) in stageListCopy" :key="key" class="bm">
                <div class="bm title">{{data.stageName}}</div>
                <div class>
                    <el-checkbox
                        :indeterminate="data.isIndeterminate"
                        v-model="data.checkAll"
                        @change="handleCheckAllChange(data.checkAll, key)"
                    >全选</el-checkbox>
                    <!-- <div style="margin: 15px 0;"></div> -->
                    <el-checkbox-group
                        v-model="checkedData"
                        @change="handleCheckedChange(checkedData, key)"
                    >
                        <el-checkbox
                            v-for="project in data.itemList"
                            :label="project"
                            :key="project.subProjectName"
                        >
                            {{ project.subProjectName }}
                            <el-tooltip
                                v-if="project.subProjectDesc && project.subProjectDesc.length>0"
                                class="item"
                                effect="dark"
                                :content="project.subProjectDesc"
                                placement="top-start"
                            >
                                <span>
                                    <i class="el-icon-info"></i>
                                </span>
                            </el-tooltip>
                            <!-- <span  v-if="project.subProjectDesc.length>0" >
                                 <i class="el-icon-info">
                                    <div class="tangchuang" >
                                        <div class="similar-name bm bm-ver el-popover">
                                            <div x-arrow="" class="x-popper__arrow"></div>
                                            <div class="bm bm-wrap similar-list" >
                                               <p> {{project.subProjectDesc}}</p>
                                            </div>
                                        </div>
                                    </div>
                                </i>
                            </span>-->
                        </el-checkbox>
                    </el-checkbox-group>
                </div>
            </div>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button @click="cancel" size="small">取消</el-button>
            <el-button type="primary" @click="finish" size="small">完成</el-button>
        </span>
    </el-dialog>
</template>
<script>
import { crmApi } from "@/services";
import { setTimeout } from "timers";
// import moment from 'moment'
// const R = require("ramda");
export default {
    props: {
        visible: {
            type: Boolean,
            required: true
        },
        stageList: {
            type: Array,
            required: true
        },
        chooseList: {
            type: Array,
            required: true
        }
    },
    data() {
        return {
            stageListCopy: [],
            checkedData: [],
            checkedDataTemp: []
        };
    },
    watch: {
        stageList: function() {
            this.stageListCopy = this.stageList;
            this.checkedData = []; //先清空
            this.checkedDataTemp = [];
            this.stageListCopy.forEach((list, listKey) => {
                let array = [];
                list.itemList.forEach((item, itemKey) => {
                    this.chooseList.forEach((data, dataKey) => {
                        if (
                            R.findIndex(
                                R.propEq("subProjectCode", item.subProjectCode)
                            )(data.budgetSubDetail) != -1
                        ) {
                            let budgetSubDetailObj = R.find(
                                R.propEq("subProjectCode", item.subProjectCode)
                            )(data.budgetSubDetail);
                            array.push(item);
                            this.checkedData.push(item);
                            this.checkedDataTemp.push(budgetSubDetailObj);
                        }
                    });
                });
                let checkedCount = array.length;
                list.checkAll = checkedCount === list.itemList.length;
                list.isIndeterminate =
                    checkedCount > 0 && checkedCount < list.itemList.length;
            });
        },
        chooseList: {
            handler: function(newValue, oldValue) {
                this.checkedData = []; //先清空
                this.checkedDataTemp = [];
                this.stageListCopy.forEach((list, listKey) => {
                    let array = [];
                    list.itemList.forEach((item, itemKey) => {
                        this.chooseList.forEach((data, dataKey) => {
                            if (
                                R.findIndex(
                                    R.propEq(
                                        "subProjectCode",
                                        item.subProjectCode
                                    )
                                )(data.budgetSubDetail) != -1
                            ) {
                                let budgetSubDetailObj = R.find(
                                    R.propEq(
                                        "subProjectCode",
                                        item.subProjectCode
                                    )
                                )(data.budgetSubDetail);
                                array.push(item);
                                this.checkedData.push(item);
                                this.checkedDataTemp.push(budgetSubDetailObj);
                            }
                        });
                    });
                    let checkedCount = array.length;
                    list.checkAll = checkedCount === list.itemList.length;
                    list.isIndeterminate =
                        checkedCount > 0 && checkedCount < list.itemList.length;
                });
            },
            immediate: true,
            deep: true
        }
    },
    methods: {
        mounted() {
            console.log("mounted choose-project-stage");
        },
        handleCheckAllChange(val, key) {
            this.stageListCopy[key].itemList.forEach((item, itemKey) => {
                this.checkedData.forEach((data, dataKey) => {
                    if (data.subProjectCode == item.subProjectCode) {
                        this.checkedData.splice(dataKey, 1);
                    }
                });
            });
            if (val) {
                for (let item of this.stageListCopy[key].itemList) {
                    this.checkedData.push(item);
                }
            }
            this.stageListCopy[key].isIndeterminate = false;
        },
        handleCheckedChange(value, key) {
            let array = [];
            this.stageListCopy[key].itemList.forEach((item, itemKey) => {
                value.forEach((data, dataKey) => {
                    if (data.subProjectCode == item.subProjectCode) {
                        array.push(item);
                    }
                });
            });
            let checkedCount = array.length;
            this.stageListCopy[key].checkAll =
                checkedCount === this.stageListCopy[key].itemList.length;
            this.stageListCopy[key].isIndeterminate =
                checkedCount > 0 &&
                checkedCount < this.stageListCopy[key].itemList.length;
            this.stageListCopy = Object.assign([], this.stageListCopy);
        },
        cancel() {
            this.$emit("close", this.current);
        },
        finish() {
            let budgetDetail = [];
            this.stageListCopy.forEach((list, listKey) => {
                let budgetSubDetail = [];
                this.checkedData.forEach((data, dataKey) => {
                    if (
                        R.findIndex(
                            R.propEq("subProjectCode", data.subProjectCode)
                        )(list.itemList) != -1
                    ) {
                        let tempObj = R.find(
                            R.propEq("subProjectCode", data.subProjectCode)
                        )(this.checkedDataTemp);
                        console.log("x", tempObj);
                        if (R.isNil(tempObj) || R.isEmpty(tempObj)) {
                            budgetSubDetail.push({
                                subProjectCode: data.subProjectCode,
                                subProjectName: data.subProjectName,
                                subProjectDesc: data.subProjectDesc,
                                investmentTotal: data.investmentTotal,
                                currentProgress: data.currentProgress,
                                currentInvestment: data.currentInvestment,
                                currentYear: moment().format("YYYY"),
                                nextYear: parseInt(moment().format("YYYY")) + 1,
                                currentYearInvestment:
                                    data.currentYearInvestment,
                                currentYearProgress: data.currentYearProgress,
                                currentYearUnfinishedInvestment:
                                    data.currentYearUnfinishedInvestment,
                                nextYearInvestment: data.nextYearInvestment,
                                nextYearProgress: data.nextYearProgress,
                                nextYearUnfinishedInvestment:
                                    data.nextYearUnfinishedInvestment
                            });
                        } else {
                            budgetSubDetail.push({
                                subProjectCode: tempObj.subProjectCode
                                    ? tempObj.subProjectCode
                                    : data.subProjectCode,
                                subProjectName: tempObj.subProjectName
                                    ? tempObj.subProjectName
                                    : data.subProjectName,
                                subProjectDesc: tempObj.subProjectDesc
                                    ? tempObj.subProjectDesc
                                    : data.subProjectDesc,
                                investmentTotal: (tempObj.investmentTotal||tempObj.investmentTotal==0)
                                    ? tempObj.investmentTotal
                                    : data.investmentTotal,
                                currentProgress: (tempObj.currentProgress||tempObj.currentProgress==0)
                                    ? tempObj.currentProgress
                                    : data.currentProgress,
                                currentInvestment: (tempObj.currentInvestment||tempObj.currentInvestment==0)
                                    ? tempObj.currentInvestment
                                    : data.currentInvestment,
                                currentYear: tempObj.currentYear
                                    ? tempObj.currentYear
                                    : moment().format("YYYY"),
                                nextYear: tempObj.nextYear
                                    ? tempObj.nextYear
                                    : parseInt(moment().format("YYYY")) + 1,
                                currentYearInvestment: (tempObj.currentYearInvestment||tempObj.currentYearInvestment==0)
                                    ? tempObj.currentYearInvestment
                                    : data.currentYearInvestment,
                                currentYearProgress: (tempObj.currentYearProgress||tempObj.currentYearProgress==0)
                                    ? tempObj.currentYearProgress
                                    : data.currentYearProgress,
                                currentYearUnfinishedInvestment: (tempObj.currentYearUnfinishedInvestment||tempObj.currentYearUnfinishedInvestment==0)
                                    ? tempObj.currentYearUnfinishedInvestment
                                    : data.currentYearUnfinishedInvestment,
                                nextYearInvestment: (tempObj.nextYearInvestment||tempObj.nextYearInvestment==0)
                                    ? tempObj.nextYearInvestment
                                    : data.nextYearInvestment,
                                nextYearProgress: (tempObj.nextYearProgress||tempObj.nextYearProgress==0)
                                    ? tempObj.nextYearProgress
                                    : data.nextYearProgress,
                                nextYearUnfinishedInvestment: (tempObj.nextYearUnfinishedInvestment||tempObj.nextYearUnfinishedInvestment==0)
                                    ? tempObj.nextYearUnfinishedInvestment
                                    : data.nextYearUnfinishedInvestment
                            });
                        }
                    }
                });
                if (budgetSubDetail.length > 0) {
                    budgetDetail.push({
                        stageCode: list.stageCode,
                        stageName: list.stageName,
                        budgetSubDetail: budgetSubDetail
                    });
                }
            });
            this.$emit("finish", budgetDetail);
        },
        befclose() {
            this.$emit("close");
        }
    }
};
</script>
<style lang="scss" scoped>
.el-dialog__wrapper {
    /deep/.el-dialog__header {
        padding: 21px 0px 18px 23px;
        border-bottom: 1px solid #dcdfe5;
    }
    /deep/.el-dialog__title {
        color: #323232;
        font-weight: bolder;
    }
    /deep/.el-dialog__body {
        height: 350px;
        overflow: auto;
        padding: 10px 20px;
        // .tangchuang{
        //     // display: none;
        //     position: absolute;
        //     top:0px;
        //     .el-popover{
        //         position: absolute;
        //         background: #fff;
        //         min-width: 138px;
        //         border-radius: 4px;
        //         border: 1px solid #ebeef5;
        //         padding: 0px;
        //         z-index: 2000;
        //         color: #606266;
        //         line-height: 1.4;
        //         text-align: justify;
        //         font-size: 14px;
        //         box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
        //         word-break: break-all;
        //     }
        //     .similar-name{
        //         position: absolute;
        //         top: 22px;
        //         left: -300px;
        //         // right: -413px;
        //         border: solid 1px #dddfe5;
        //         // box-shadow: inset 0px -1px 0px 0px #ececec, inset 0px 1px 0px 0px #ececec;
        //         width: 333px;
        //         height: 116px;
        //         z-index: 90;
        //         .similar-title{
        //             font-size: 14px;
        //             // line-height: 50px;
        //             letter-spacing: 1px;
        //             color: #c1c4cc;
        //         }
        //         .similar-list{
        //             padding:  18px 18px 18px 18px;
        //         }
        //         .x-popper__arrow{
        //             position: absolute;
        //             left: -18px;
        //         }
        //         .x-popper__arrow:after,.x-popper__arrow:before {
        //             top: -12px;
        //             left: 318px;
        //             width: 0;
        //             height: 0;
        //             border: 6px solid transparent;
        //             border-bottom-color: #dddfe5;
        //             position: absolute;
        //             content: "";
        //         }
        //         .x-popper__arrow:before{
        //             top: -10px;
        //             left: 318px;
        //             border-bottom-color: white;
        //             z-index: 999;
        //         }
        //     }
        // }
    }
    .title {
        font-size: 16px;
        color: #323232;
        font-weight: bold;
        margin-left: 29px;
        width: 100px;
    }
    /deep/.el-checkbox-group {
        max-width: 600px;
    }
    /deep/.el-checkbox {
        width: 300px;
        color: #646464;
        margin-bottom: 15px;
    }
    /deep/.el-checkbox + .el-checkbox {
        margin-left: 0;
    }

    .el-icon-info {
        color: #ff8813;
    }
    .el-icon-info:hover .tangchuang {
        display: block;
    }
    .choseBtn {
        .btn {
            width: 70%;
            margin: 10px;
            position: relative;
            background: #f5f6fb;
            border-radius: 0;
            border: 0;
            span {
                width: 15px;
                height: 15px;
                // background: red;
                background-image: url(../../asserts/img/btn_xuanzhong.png);
                position: absolute;
                z-index: 100;
                top: -1px;
                right: -1px;
            }
        }
        .btn-border {
            border: 1px solid #409eff;
        }
    }
}
</style>
